import { NgModule } from '@angular/core';
import { RelativeTimePipe } from './common/relative-time.pipe';
import { ExcerptPipe } from "./common/excerpt.pipe";
import { KeysPipe } from './common/keys.pipe';
import { SafePipe } from './common/safe.pipe';
import { SanitizeHtmlPipe } from './common/sanitize-html.pipe';
import { BrPipe } from './common/br.pipe';
import { CurrencyFormatPipe } from './common/currencyFormat.pipe';
 @NgModule({
  imports: [
    RelativeTimePipe,
    ExcerptPipe,
    KeysPipe,
    SanitizeHtmlPipe,
    BrPipe,
    ExcerptPipe,
    KeysPipe,
    SafePipe,
    SanitizeHtmlPipe,
    BrPipe,
    CurrencyFormatPipe
  ],
  exports: [
    RelativeTimePipe,
    ExcerptPipe,
    KeysPipe,
    SanitizeHtmlPipe,
    BrPipe,
    ExcerptPipe,
    KeysPipe,
    SafePipe,
    SanitizeHtmlPipe,
    BrPipe,
    CurrencyFormatPipe
  ]
})
export class CommonPipesModule { }